export const initialState = {
	posts: {
		list: []
	},
	users: {
		isSignedIn: false,
		role: "",
		uid: "",
		username: ""
	},
};